"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinClampDiodeParametricSchema = exports.PinClampDiodeParametric = void 0;
const zod_1 = require("zod");
var PinClampDiodeParametric;
(function (PinClampDiodeParametric) {
    PinClampDiodeParametric["ClampUp"] = "clamp-up";
    PinClampDiodeParametric["ClampDown"] = "clamp-down";
})(PinClampDiodeParametric || (exports.PinClampDiodeParametric = PinClampDiodeParametric = {}));
exports.PinClampDiodeParametricSchema = zod_1.z.nativeEnum(PinClampDiodeParametric);
//# sourceMappingURL=PinClampDiodeParametric.js.map